import axios from '@/libs/axios'

const emptySummary = () => ({ total: 0, to_respond: [], to_approve: [] })

export default {
  namespaced: true,
  state: {
    summary: emptySummary(),
    loading: false,
    lastFetch: 0,
  },
  getters: {
    total: state => state.summary.total,
    asPeer: state => state.summary.to_respond,
    asApprover: state => state.summary.to_approve,
  },
  mutations: {
    SET_SUMMARY(state, summary) {
      state.summary = Object.assign(emptySummary(), summary)
      state.lastFetch = Date.now()
    },
    SET_LOADING(state, value) {
      state.loading = value
    },
    RESET(state) {
      state.summary = emptySummary()
      state.lastFetch = 0
    },
  },
  actions: {
    async fetch({ commit, state, rootState }, { maxAge = 0 } = {}) {
      if (state.loading) return
      if (maxAge && state.lastFetch && Date.now() - state.lastFetch < maxAge) return

      commit('SET_LOADING', true)
      const res = await axios.get(`${rootState.api}pending-summary`).catch(() => null)
      if (res && res.data && res.data.success) {
        commit('SET_SUMMARY', res.data.data || {})
      }
      commit('SET_LOADING', false)
    },
  },
}
